export enum MapProviders {
  TOMTOM = 'tomtom',
  GOOGLE = 'google',
  MAP_FALLBACK = 'mapFallback',
}
